import { QuizBaseSchema } from './QuizBaseSchema';
import { QuizEssayDataSchema } from './QuizEssayDataSchema';
import { QuizMatchDataSchema } from './QuizMatchDataSchema';
import { QuizMultipleDataSchema } from './QuizMultipleDataSchema';
import { QuizOrderDataSchema } from './QuizOrderDataSchema';
import { QuizOXDataSchema } from './QuizOXDataSchema';
import { QuizSubjectiveDataSchema } from './QuizSubjectiveDataSchema';

export const QuizSchema = {
  Base: QuizBaseSchema,
  Multiple: QuizMultipleDataSchema,
  Subjective: QuizSubjectiveDataSchema,
  OX: QuizOXDataSchema,
  Match: QuizMatchDataSchema,
  Essay: QuizEssayDataSchema,
  Order: QuizOrderDataSchema,
};
